const state = () => ({
  uploadList: [],
  uploadBtnId: "",
  contentInstance: {}, // 子应用内容实例
  prefix: undefined, // 批量前缀
  uploadStatus: {}, // 上传状态
  isShowUploadModal: undefined,
  isDetail: false,
  detailInfo: {}
});

const getters = {
  getUploadList: state => state.uploadList,
  getUploadBtnId: state => state.uploadBtnId,
  getContentInstance: state => state.contentInstance,
  getPrefix: state => state.prefix,
  getUploadStatus: state => state.uploadStatus,
  getIsShowUploadModal: state => state.isShowUploadModal,
  getIsDetail: state => state.isDetail,
  getDetailInfo: state => state.detailInfo
};

// 消息队列：缓存所有推送的数据
const updateQueue = [];

// 是否正在等待下一批处理（防抖用）
let isProcessing = false;


// 方法：增量更新 list
function updateList(list, data) {
  // 用 Map 存储当前 list 的索引，便于快速查找
  const map = new Map();
  list.forEach((item, index) => {
    map.set(item.tid, index);
  });

  // 遍历推送数据
  data.forEach(item => {
    const { tid } = item;
    if (map.has(tid)) {
      // 已存在，更新 name
      const index = map.get(tid);
      list[index] = item;
    } else {
      // 新数据，添加到末尾，并更新 map
      map.set(tid, list.length);
      list.push(item);
    }
  });

  // 返回更新后的 list（可选）
  return list;
}


const actions = {
  async setUploadList({ commit, state }, list) {
    if (!Array.isArray(list) || list.length === 0) {
      commit("setUploadList", []);
      return;
    }
    updateQueue.push(list);
    // 触发处理（防抖）
    if (!isProcessing) {
      isProcessing = true;
      function processQueue(){
        if (updateQueue.length === 0) {
          isProcessing = false;
          return;
        }
        const arr = updateQueue.shift();
        // 处理数据
        const data = updateList(state.uploadList, arr);
        commit("setUploadList", data);
        // 继续处理下一批
        processQueue(); 
      }
      processQueue(); 
    }
  },
  setUploadId({ commit }, id) {
    commit("setUploadId", id);
  },
  uploadBtnClick({ commit, state }) {
    let btn = document.getElementById(state.uploadBtnId);
    btn && btn.click();
  },
  setContentInstance({ commit }, instance) {
    commit("setContentInstance", instance);
  },
  setPrefix({ commit }, prefix) {
    commit("setPrefix", prefix);
  },
  setUploadStatus({ commit }, data) {
    commit("setUploadStatus", data);
  },
  setIsShowUploadModal({ commit }, isShowUploadModal) {
    commit("setIsShowUploadModal", isShowUploadModal);
  },
  setIsDetail({ commit }, isDetail) {
    commit("setIsDetail", isDetail);
  },
  setDetailInfo({ commit }, info) {
    commit("setDetailInfo", info);
  }
};

const mutations = {
  setUploadList(state, list) {
    state.uploadList = list;
  },
  setUploadId(state, id) {
    state.uploadBtnId = id;
  },
  setContentInstance(state, instance) {
    state.contentInstance = instance;
  },
  setPrefix(state, prefix) {
    state.prefix = prefix;
  },
  setUploadStatus(state, data) {
    state.uploadStatus = data;
  },
  setIsShowUploadModal(state, isShowUploadModal) {
    state.isShowUploadModal = isShowUploadModal;
  },
  setIsDetail(state, isDetail) {
    state.isDetail = isDetail;
  },
  setDetailInfo(state, info) {
    state.detailInfo = info;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
